export const getCookieName = () => {
  return import.meta.env.VITE_COOKIE_NAME || 'digitane_token'
}
